module.exports = __webpack_public_path__ + "static/media/Franco Costa.3d242e56.png";